// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"419cc6a2","453":"162d616f","455":"8023c5c3","977":"a3e3cb55"}[chunkId] + ".chunk.js";
};